import React, {Suspense, useEffect, useMemo, useState} from 'react';
import {browserHistory, IndexRoute, Route, Router} from 'react-router';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import {isDesktopSafari} from 'sources/webrtc/streams/browserDetector';
import SnackbarContainer from 'components/controls/snackbar/SnackbarContainer';
import SpinnerBox from './controls/SpinnerBox';
import ThemeProvider from "./ThemeProvider";
import {UIContextProvider} from "../sources/contexts/UiContext";
import RootPage from "./layouts/RootPage";
import IndexPage from "./Index/IndexPage";

const App = () => {
        const [section, onActivateLandingSection] = useState(null);
        useEffect(() => {
            if (isDesktopSafari()) {
                const viewportMeta = document.querySelector('meta[name="viewport"]');
                viewportMeta.setAttribute('content', 'width=1440');
            }
        }, []);

        const index = useMemo(() => {
            const content = (props) => <IndexPage
                hashKey={location.hash}
                onActivateLandingSection={onActivateLandingSection}
                {...props}
            />;

            return <IndexRoute component={content} />
        }, [section]);

        return (
            <div style={{height: '100%'}}>
                <ThemeProvider>
                    <UIContextProvider>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <Suspense fallback={<SpinnerBox overlay />}>
                                <Router history={browserHistory} children={
                                    <Route path='/' component={(props) => <RootPage onActivateLandingSection={onActivateLandingSection} {...props}/>} >
                                        {index}
                                    </Route>
                                } />
                            </Suspense>
                            <SnackbarContainer />
                        </MuiPickersUtilsProvider>
                    </UIContextProvider>
                </ThemeProvider>
            </div>
        );
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js